import type { ReactNode } from "react";
import { AppLayout } from "@/components/layout/AppLayout";

/**
 * The one-screen frame every entity list uses. At lg and up the tiles and the
 * toolbar keep their height, and the panel takes the rest: whatever sits in
 * `children` (an AirtableGrid with `scroll`, or a board) scrolls inside it,
 * above the pager. Below lg nothing is height-constrained and the page scrolls.
 */
export function ListShell({ title, tiles, toolbar, above, children, footer, after }: {
  title: string;
  tiles?: ReactNode;
  toolbar: ReactNode;
  /** Banners, bulk bars and strips that sit between the toolbar and the panel. */
  above?: ReactNode;
  children: ReactNode;
  /** Usually a compact ListPager. */
  footer?: ReactNode;
  /** Dialogs and drawers, rendered after the frame. */
  after?: ReactNode;
}) {
  return (
    <AppLayout title={title} fill>
      <div className="flex flex-col gap-3 lg:flex-1 lg:min-h-0 page-enter" data-testid="list-shell">
        {tiles && <div className="shrink-0">{tiles}</div>}
        <div className="shrink-0">{toolbar}</div>
        {above && <div className="shrink-0 space-y-2">{above}</div>}
        <section className="bg-card border border-border rounded-lg overflow-hidden flex flex-col lg:flex-1 lg:min-h-0" data-testid="list-panel">
          <div className="flex flex-col lg:flex-1 lg:min-h-0">{children}</div>
          {footer && <div className="shrink-0 border-t border-border px-3">{footer}</div>}
        </section>
      </div>
      {after}
    </AppLayout>
  );
}
